import CriticalVideoLoader from './src/CriticalVideoLoader';

export { 
    CriticalVideoLoader, 
};